import { CONNECTION } from "../models/common/common";
import { ApiConnection } from "../models/connection";
import { authenticate } from "../utils/function-utils";

//AVCDAMOSHI.002  18/03/2025  Add code for  Add check regiser type page

export const getConnectionApi = (url?: keyof ApiConnection, type?: CONNECTION): 
    [string, HeadersInit, ApiConnection] => 
{
    const conn = window.sessionStorage.getItem("connection");
    if (!conn) {
        throw new Error("No connection found");
    }
    const response: ApiConnection = JSON.parse(conn)[0];

    let api_url: string = "";
    let headers: HeadersInit = {};
    
    if (url && type) {
        switch (type) {  
            case CONNECTION.BC : { 
                api_url = response.BC_Api_Endpoint + response[url]
                headers = {
                    "Content-Type": "application/json",
                    "Authorization": authenticate(response.BC_Api_Username, response.BC_Api_Password)
                }
                break;
            };
            case CONNECTION.OTP : {
                api_url = response.Otp_Sms_Provider_Endpoint + response[url]
                headers = {
                    "Content-Type": "application/json",
                    "api_key": response.Otp_Sms_Provider_Api_Key,
                    "secret_key": response.Otp_Sms_Provider_Api_Secret,
                }
                break;
            }    
            default : {
                api_url = response.Web_Api_Endpoint + response[url]
                headers = {
                    "Content-Type": "application/json",
                    "Authorization": authenticate(response.Web_Api_Username, response.Web_Api_Password)
                }
                break;
            }
        }
    }

    return [ api_url, headers, response ];
}

//C-AVCDAMOSHI.002  18/03/2025  Add code for  Add check regiser type page